import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromGuide from './reducers/guide.reducer';
import { EffectsModule } from '@ngrx/effects';
import { GuideEffects } from './effects/guide.effects';
import { GuideService } from './services/guide.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromGuide.guideStoreFeatureKey, fromGuide.reducer),
    EffectsModule.forFeature([GuideEffects]),
  ],
  providers: [GuideService],
})
export class GuideStoreModule {}
